// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3hboU","calendarButtons":"ClockData_calendarButtons__cwNtE"};